// @flow
import styled, { keyframes } from 'styled-components';
import {
    ANIMATION_KEY_IMPLODE,
    ANIMATION_KEY_SLIDE,
    ANIMATION_IMPLODE_DURATION,
    ANIMATION_SLIDE_ENTER_DURATION,
    ANIMATION_SLIDE_EXIT_DURATION
} from './constants';
import { easing, implode, shrinkExpand, slideDownAndGrow, slideUp } from '~/core/constants/animations';
import CSSTransition from 'react-transition-group/CSSTransition';
import SVGIcon from '~/core/icons/svg-icons';

const generalIconSize = '2.5em';
const menuHeight = '2.75em';

export const shrinkExpandAgain = keyframes`
	0% { transform: scale(1); }
	25% { transform: scale(0.84); }
	75% { transform: scale(0.84); }
	100% { transform: scale(1); }
`;

const animateShrink = `${shrinkExpand} 0.8s ${easing.bounce} 1`;
const animateShrinkAgain = `${shrinkExpandAgain} 0.8s ${easing.bounce} 1`;
const animateSlideAndGrow = `${slideDownAndGrow} ${ANIMATION_SLIDE_ENTER_DURATION}ms ${easing.bounce} 1`;
const animateSlideUp = `${slideUp} ${ANIMATION_SLIDE_EXIT_DURATION}ms ${easing.bounce} 1`;
const animateImplode = `${implode} ${ANIMATION_IMPLODE_DURATION}ms linear`;

export const ModeSelector = styled.div`position: relative;`;

export const ModeItemWrapper = styled.div`
    align-items: center;
    border: ${({ theme }) => `1px solid ${theme.fadedGrey}`};
    border-radius: 1.5em;
    display: flex;
    height: ${menuHeight};
    position: relative;
`;

export const ModeItem = styled.div`
    align-items: center;
    color: ${({ theme, disabled }) => (disabled ? theme.mediumGrey : theme.primaryFontColor)};
    cursor: pointer;
    display: flex;
    font-size: 1.1em;
    justify-content: center;
    text-align: center;
    width: ${({ itemWidth }) => `${itemWidth}%`};
    & span {
        font-size: ${generalIconSize};
    }
`;

export const ModeIcon = styled(SVGIcon)`
    height: 1.25em;
    margin-right: 0.25em;
    width: 1.25em;
    & g {
        fill: ${props => props.theme.primaryFontColor};
    }
`;

export const ActiveIndicatorWrapper = styled.div`
    left: 0;
    position: absolute;
    top: 0;
    transition: transform 0.2s linear 0.25s;
    transform: ${({ itemCount, itemWidth, selectedIndex }) => `translateX(${itemWidth * itemCount * selectedIndex}%)`};
    width: ${({ itemWidth }) => `${itemWidth}%`};
`;

export const ActiveIndicator = styled.div`
    animation: ${props => (props.activeAnimate ? animateShrink : animateShrinkAgain)};
    border: ${({ theme, disabled }) => (disabled ? 'none' : `1px solid ${theme.mainBrandColor}`)};
    border-radius: 1.5em;
    height: ${menuHeight};
`;

export const DescriptionWrapper = styled.div`
    height: 3em;
    overflow: hidden;
    padding: 1em 0;
    position: relative;
    text-align: center;
`;

export const TransitionWrapper = styled(CSSTransition)`
    left: 0;
    position: absolute;
    top: 1em;
    width: 100%;

    &.${ANIMATION_KEY_SLIDE}-enter {
        animation: ${animateSlideAndGrow};
    }

    &.${ANIMATION_KEY_SLIDE}-exit {
        animation: ${animateSlideUp};
    }

    &.${ANIMATION_KEY_IMPLODE}-enter {
        animation: ${animateImplode};
    }

    &.${ANIMATION_KEY_IMPLODE}-exit {
        animation: ${animateImplode};
    }
`;

export const Description = styled.div`color: ${({ theme }) => theme.offlineGrey};`;



// WEBPACK FOOTER //
// ./src/components/widgets/mode-selector-block/styled.js